export const DISCOVERY_PREFIX = 'discovery/api/v1';
export const BENTO_PREFIX = 'api/v1';
export const ARROW_PREFIX = 'arrow/api';
export const PDS_PREFIX = 'pds/v1';
export const PREAUTH_PREFIX = 'preauth/api';
export const privacyLink = 'https://www.smarterhealth.com/privacy-policy';
